<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.staff.tagName`),
      tagLink: `${searchResult.link}/staff`,
    }"
    class="staff-card result-card"
  >
    <template #preview>
      <div
        v-if="searchResult?.avatar_url"
        class="preview-image"
      >
        <img
          :src="modifiedStaffImage"
          alt=""
        />
      </div>
      <div
        v-else
        class="preview-fallback"
      >
        <Icon
          name="lucide:user"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <div class="staff-content">
        <NuxtLink
          class="full-name"
          :to="`${searchResult.link}/staff?=${searchResult.id}`"
        >
          {{ searchResult.full_name }}
        </NuxtLink>
        <div class="staff-title">{{ searchResult.title }}</div>
      </div>

      <div class="phone-and-email">
        <div
          v-if="searchResult.phone_number"
          class="meta-info"
        >
          <Icon
            class="phone-icon"
            name="lucide:phone"
            size="14"
          />{{ searchResult.phone_number }}
        </div>
        <div
          v-if="searchResult.email"
          class="meta-info"
        >
          <Icon
            class="mail-icon"
            name="lucide:mail"
            size="14"
          />{{ searchResult.email }}
        </div>
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import { computed } from 'vue';

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
});
// this requires a backend ticket to provide us with a different non -modified staff image. Until then - this will suffice
const modifiedStaffImage = computed(() => {
  if (!props.searchResult.avatar_url) return '';
  const strReplace = props.searchResult.avatar_url;
  const partToRemove = 'small_';
  const resultReplace = strReplace.replace(partToRemove, '');
  return resultReplace;
});
</script>

<style scoped>
.staff-card {
  --background-color: #f7f5f9;
  --text-color: #2d2d2d;
  --color-text-secondary: #474747;

  .staff-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .full-name {
    color: var(--text-color);
    font-family: 'Inter';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: 0.8px;
    text-decoration: none;
    width: fit-content;
  }
  .phone-and-email {
    display: flex;
    color: var(--color-text-secondary);
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    gap: 24px;
  }
  .meta-info {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
  }
}
</style>
